import { render, staticRenderFns } from "./QUniqueBuildersDrilldown.vue?vue&type=template&id=22c7835e&scoped=true&"
import script from "./QUniqueBuildersDrilldown.vue?vue&type=script&lang=js&"
export * from "./QUniqueBuildersDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7835e",
  null
  
)

export default component.exports